import React, { useState } from "react";
import s from "./TableWrapper.module.scss";
import useSWR from "swr";
import { PaginatedUserAPI } from "../../../../../../../../../libs/Utils/Types/APIManagement";
import { swrFetcher } from "../../../../../../../../../libs/api/Endpoints";
import { UseAuthToken } from "../../../../../../../../../libs/api/userSession";
import ReusablePopover from "../../../../../../../../../global components/Popover/ReuseablePopover";
import FilterPopOverContent from "../FilterPopOverContent";
import { FilterIcon } from "../../../../../../../../../global components/Icons/FilterIcon";
import Paginate from "../../../../../../../../../global components/Paginate/Pagination";
import RequestTable from "../RequestTable";
type PropType = {
  id: string;
};
function TableWrapper({ id }: PropType) {
  const token = UseAuthToken();
  const [currentPage, setCurrentPage] = useState(1);
  const [pageItems, setPageItems] = useState(100);
  const [status, setStatus] = useState<"active" | "revoked" | "disabled">();
  const { data, isLoading, mutate } = useSWR<PaginatedUserAPI, any, any>(
    token
      ? [
          `api/admin/api-keys/users/${id}/keys`,
          token,
          {
            ...(status && { status: status }),
            ...(currentPage && { page: currentPage }),
            ...(pageItems && { limit: pageItems }),
          },
        ]
      : null,
    swrFetcher,
  );

  const handlePageChange = (page: number, size: number) => {
    setCurrentPage(page);
    setPageItems(size);
  };
  return (
    <div className={s.wrapper}>
      <div className={s.head}>
        <div className={s.filterWrapper}>
          <ReusablePopover
            placement="rightTop"
            content={
              <FilterPopOverContent setStatus={setStatus} status={status} />
            }
            trigger={"hover"}
          >
            <button className={s.filter}>
              <FilterIcon className={s.filterIcon} />
              <p>Filter</p>
            </button>
          </ReusablePopover>
        </div>
        <Paginate
          onChange={handlePageChange}
          total={data?.pagination.totalItems || 0}
          pageSize={pageItems}
        />
      </div>
      <RequestTable
        data={data?.data || []}
        loading={isLoading}
        mutate={mutate}
      />
    </div>
  );
}

export default TableWrapper;
